import { isObject } from 'src/utils'

export const isPWAPopupDenied = (state) => state.pwaPopupDenied

export const getCartPersistedInfo = (state) => (cartNumber) =>
  state.cartPersistedInfo && state.cartPersistedInfo[cartNumber]
    ? state.cartPersistedInfo[cartNumber]
    : null

export const isCartSectionPined = (state) => state.isCartSectionPined

export const getFilterByPage = (state) => (page) => {
  // Check if filters exist for the page
  if (state.filters?.[page] && isObject(state.filters[page])) {
    return state.filters[page]
  }

  // Default filter configurations by page type
  const defaultFilters = {
    favorite: {
      sortBy: 0,
      category: '',
      isListView: false,
    },
    wishlist: {
      sortBy: 'Price Low to High',
      isListView: false,
    },
    order: {
      selectedFilter: 'All Orders',
      filterOptions: [],
    },
    'auto-ship-order': {
      filterByStatus: '',
      filterByUpcoming: '',
      StartDate: '',
      EndDate: '',
    },
  }

  // Return page-specific defaults if they exist, otherwise return generic defaults
  return (
    defaultFilters[page] || {
      sortBy: 'Price Low to High',
      pageSize: '10',
      isListView: false,
    }
  )
}

export const orderFilters = (state) => state.orderFilters

export const showAppDownloadNotification = (state) =>
  state.showAppDownloadNotification

export const disclaimerUpdate = (state) => state.disclaimerUpdate

export const announcementUpdate = (state) => state.announcementUpdate

export const selectedDeliveryAddress = (state) => state.deliveryAddress

export const selectedAddressForFulfillmentCode = (
  state,
  getters,
  rootState,
  rootGetters
) => {
  return (fulfillmentCode) => {
    let cartDetail = rootGetters['cart/currentCartDetails']
    let selectedAddress
    // let selectedAddress = state.selectedAddress[fulfillmentCode]
    // if (selectedAddress) {
    //   let addressAvailable = rootGetters['address/getAddressByAddressID'](
    //     selectedAddress.addressId
    //   )
    //   return addressAvailable
    //     ? addressAvailable
    //     : rootGetters['address/defaultAddress']
    // }

    if (cartDetail?.fulfillments) {
      for (let fId in cartDetail.fulfillments) {
        let fulfillment = cartDetail.fulfillments[fId]
        if (fulfillment.codeName == fulfillmentCode && fulfillment.addressID) {
          for (let key in rootGetters['address/addresses']) {
            if (key == fulfillment.addressID) {
              selectedAddress = rootGetters['address/addresses'][key]
            }
          }
        }
      }
    }

    // return default address
    if (!selectedAddress)
      selectedAddress = rootGetters['address/defaultAddress']
    return selectedAddress
  }
}

export const subscribeToLNS = (state) => !!state.subscribeToLNS

export const isContactlessdelivery = (state) => state.isContactlessdelivery

export const announcementsRead = (state) => state.announcementsReadUpdate
